import styled, { css } from 'styled-components';

export const Pill = styled.button<{ color?: string; active?: boolean; short?: boolean }>`
  display: inline-flex;
  justify-content: center;
  align-items: center;

  padding: 0 24px 0 16px;
  border-radius: 9999px;
  font-size: 0.875rem;
  font-weight: 400;
  color: #2e2e3a;
  background: white;
  height: 36px;
  min-width: 108px;
  ${(props) =>
    props.short &&
    css`
      width: 34px;
      height: 34px;

      min-width: unset;
      padding: 0;

      &:hover {
        width: 36px;
        height: 36px;
      }
    `}
  text-align: center;

  margin-right: calc(10px + 1px);
  border: 1px solid #e2e2ea;
  margin-left: 1px;
  margin-top: 1px;
  margin-bottom: 1px;
  transition: 300ms linear border-color;

  ${(props) =>
    props.onClick &&
    css`
      cursor: pointer;

      &:hover {
        border-width: 2px;
        margin-top: 0;
        margin-bottom: 0;
        margin-left: 0;
        margin-right: calc(10px);
        background-color: rgb(240, 240, 244);
      }
    `}

  ${(props) =>
    props.active &&
    props.color &&
    css`
      border-color: ${props.color};
      border-width: 2px;
      margin-top: 0;
      margin-bottom: 0;
      margin-left: 0;
      margin-right: calc(10px);
    `}
`;
